import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser'; 
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { AuthenticationService } from '../app/shared/services/authentication.service';
import { environment } from '../environments/environment';
import { GlobalConstants } from '../app/shared/services/GlobalConstants.service';
import * as am4core from '@amcharts/amcharts4/core';

@Component({
  selector: 'ara-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  windowScrolled: boolean;
  constructor(private authenticationService: AuthenticationService, @Inject(DOCUMENT) private document: Document
  , private titleService: Title) {
    this.authenticationService.initAdal8ServiceConfig();
    GlobalConstants.Initialize();
    titleService.setTitle(GlobalConstants.siteTitle);
  }
  ngOnInit() {
    if (environment.production && location.protocol === 'http:') {
      window.location.href = location.href.replace('http', 'https');
    }
    am4core.addLicense(environment.amchartKey);
   
  }
  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop > 100) {
      this.windowScrolled = true;
    }
    else if (this.windowScrolled && window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop < 10) {
      this.windowScrolled = false;
    }
  }
  scrollToTop() {
    (function smoothScroll() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothScroll);
        window.scrollTo(0, currentScroll - (currentScroll / 8));
      }
    })();
  }
}
